// Small labelled-field wrapper matching the scoped .erin-integrations design.
export default function Field({ label, required, hint, children }) {
	return (
		<div className="ei-field">
			<label className="ei-field-label">
				{label} {required && <span className="ei-field-req">*</span>}
			</label>
			{children}
			{hint && <span className="ei-field-hint">{hint}</span>}
		</div>
	);
}
